export default __webpack_public_path__ + "static/media/c2.4ce01317.jpg";